export class Bank {
    id: number;
    name: string;
    type: string;
    currency: string;
    branch_id: number;
    last_updated: string = new Date().toISOString().substr(0, 10);
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/bank.ts